import React, { useState } from "react";
import "../pagescss/CreateGame.css"; // Add your CSS styles here
import { useNavigate } from "react-router-dom";
import AvailableGames from "../component.jsx/AvailableGames";
import Header from "../component.jsx/Header";
import { API_URL } from "../component.jsx/apiConfig";

import Spinner from '../../components/Loading&Spinners/Spinner';

const CreateGame = () => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [Isloading, setIsloading] = useState(false);
  const navigate = useNavigate();

  // Get player1_id from local storage
  // const player1Id = JSON.parse(localStorage.getItem("user"))?.id;
  const player1Id = JSON.parse(localStorage.getItem("no-msisdn"));
  //
  //

  const handleCPU = () => {
    navigate("/Cpu");
  };

  const handleCreateGame = async () => {
    // Validate player1Id
    if (!player1Id) {
      setError("Player 1 ID is required");
      return;
    }

    setError(""); // Reset error message
    setMessage(""); // Reset success message
    setIsloading(true);

    try {
      // Make a POST request to create a new game
      const response = await fetch(
        `${API_URL}/api/games/create_two/${player1Id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        setIsloading(false);
        setMessage(data.message); // Display success message

        // Store the game ID and player1 ID in localStorage
        localStorage.setItem("gameId", data.gameId);
        localStorage.setItem("player1Id", data.player1Id);

        // Navigate to the game board and wait for player 2
        navigate(`/game/${data.gameId}`);
      } else {
        setIsloading(false);
        setError(data.message || "Failed to create game"); // Display error message
      }
    } catch (error) {
      setIsloading(false);
      console.error("Error creating game:", error);
      setError("Server error, please try again later");
    }
  };

  if (Isloading) return (<Spinner />)


  return (
    <div className="create-game-container">
      <Header />
      <div className="content-box">
        <h2 className="create-game-h2-heading">Create Game or play with CPU</h2>
        <div className="buttons-container">
          <button onClick={handleCPU} className="create-game-button">
            New Game (vs cpu)
          </button>
          {/* //
          //
          // */}
          {Isloading ? (
            <button
              onClick={handleCreateGame}
              className="create-game-button-vs-player"
            >
              Creating Game....
            </button>
          ) : (
            <button
              onClick={handleCreateGame}
              className="create-game-button-vs-player"
            >
              New Game (vs player )
            </button>
          )}
        </div>
        <div className="ptagserror">
          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}
        </div>

        <div className="available-games-container-create">
          <div className="mini-box">
            <h2 className="available-games-h2">Available Games to join</h2>
          </div>

          <AvailableGames />
        </div>
      </div>
    </div>
  );
};

export default CreateGame;
